import script from "./CompletedTasks.vue?vue&type=script&setup=true&lang=js"
export * from "./CompletedTasks.vue?vue&type=script&setup=true&lang=js"

import "./CompletedTasks.vue?vue&type=style&index=0&id=1b64bd05&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b64bd05"]])

export default __exports__